import { __assign, __awaiter, __generator, __rest } from '../../node_modules/tslib/tslib.es6.js';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { styled, Switch, Slide, Grid, useMediaQuery, Dialog, TextField } from '@mui/material';
import _cloneDeep from 'lodash/cloneDeep';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';
import React, { useState, useEffect, useMemo } from 'react';
import '../../api/graphQl/brand.js';
import '../../api/graphQl/product.js';
import { searchProductsRest } from '../../api/utils.js';
import brandclub_colors from '../../colors/brandclubColors.js';
import { AppCheckbox } from '../../Components/AppCheckbox/index.js';
import '../../Components/Button/BackButton.js';
import { Button } from '../../Components/Button/Button.js';
import '../../Components/Button/CloseButton.js';
import '../../Components/Button/CustomDtcBagButton.js';
import { SearchIcon } from '../../icons/SearchIcon.js';
import { brandclubStyles } from '../../styles/index.js';
import { FilterParam, getFilterParamKeyFromValue } from '../../types/filters.js';
import { TABLET_SCREEN_SIZE } from '../../utils/constants/Constants.js';
import { searchParamsToSearchFilters } from '../SearchResults/searchResultsUtils.js';

var SHOW_MORE_INITIAL_LIMIT = 6;
var SHOW_MORE_LIMIT = 100;
var BrandclubFilterSwitch = styled(function (props) { return (React.createElement(Switch, __assign({ checkedIcon: React.createElement("div", { style: {
            width: 14,
            height: 14,
            borderRadius: 100,
            backgroundColor: '#fff',
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'center',
        } },
        React.createElement(CheckRoundedIcon, { sx: function (theme) { return ({
                color: theme.palette.primary.main,
                width: 12,
                height: 12,
            }); } })), focusVisibleClassName: ".Mui-focusVisible", disableRipple: true }, props))); })(function (_a) {
    var theme = _a.theme;
    return ({
        width: 30,
        height: 20,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 3,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(10px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.primary.main,
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: 'grey',
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 14,
            height: 14,
            boxShadow: 'none',
        },
        '& .MuiSwitch-track': {
            borderRadius: 100,
            backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 300,
            }),
        },
    });
});
var Transition = React.forwardRef(function Transition(props, ref) {
    return React.createElement(Slide, __assign({ direction: "up", ref: ref }, props));
});
var FilterHeader = styled(Grid)(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            fontFamily: 'Poppins',
            color: theme.palette.primary.main,
            padding: '21px 30px',
            display: 'grid',
            gridTemplateColumns: '50px auto 50px',
            width: 690,
            borderBottom: "1px solid ".concat(brandclub_colors.blueWhite)
        },
        _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            width: '100%',
            '.center': { fontSize: 16 },
            '.right': {
                fontSize: 14,
            },
        },
        _b['.left'] = {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        _b['.center'] = {
            fontSize: 18,
            fontWeight: 600,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
        },
        _b['.right'] = {
            fontSize: 16,
            fontWeight: 500,
            color: theme.palette.primary.main,
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            cursor: 'pointer',
        },
        _b);
});
var FilterFooter = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        fontFamily: 'Poppins',
        color: theme.palette.primary.main,
        padding: '20px 0',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderTop: "1px solid ".concat(brandclub_colors.blueWhite),
        '.apply_button': {
            fontFamily: 'Poppins',
            padding: '12px 100px',
            outline: 'none',
            border: 'none',
            background: theme.palette.primary.main,
            color: '#fff',
            borderRadius: 999,
            fontSize: 16,
            fontWeight: 500,
        },
    });
});
var FilterContentContainer = styled(Grid)(function (_a) {
    var _b, _c, _d, _e, _f, _g;
    var theme = _a.theme;
    return (__assign(__assign({ color: theme.palette.primary.main, fontSize: 16, fontWeight: 500, display: 'flex', flexDirection: 'column', padding: '0 30px', width: 690, overflowY: 'scroll' }, brandclubStyles.customScrollbar), (_b = {}, _b["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
        width: '100%',
        fontSize: 14,
    }, _b['.mobile_search_bar'] = (_c = {
            display: 'none'
        },
        _c["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
            display: 'block',
        },
        _c), _b['.row'] = {
        borderBottom: "1px solid ".concat(brandclub_colors.blueWhite),
        padding: '30px 0px',
        '&:las-child': {
            borderBottom: "none",
        },
        '.row_title': (_d = {
                fontSize: 20,
                fontWeight: 600,
                marginBottom: 13
            },
            _d["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                fontSize: 14,
            },
            _d),
        '.row_options': (_e = {
                display: 'grid',
                gridTemplateColumns: '1fr 1fr'
            },
            _e["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                gridTemplateColumns: '1fr',
            },
            _e.gap = '8px',
            _e['.show_more'] = {
                textDecoration: 'underline',
                cursor: 'pointer',
            },
            _e['.option'] = {
                display: 'flex',
                alignItems: 'flex-start',
                '.option_label': {
                    wordBreak: 'break-word',
                    paddingTop: '9px',
                },
            },
            _e['.option_reward'] = (_f = {
                    display: 'flex',
                    flexWrap: 'nowrap'
                },
                _f["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                    gridColumnStart: 1,
                    gridRowStart: 1,
                },
                _f['&.right'] = (_g = {
                        gridColumnStart: 1,
                        gridRowStart: 1,
                        gridRowEnd: 3
                    },
                    _g["@media screen and (max-width: ".concat(TABLET_SCREEN_SIZE, "px)")] = {
                        gridColumnStart: 1,
                        gridRowStart: 1,
                    },
                    _g),
                _f['.toggle_text'] = {
                    marginLeft: 11,
                    maxWidth: 200,
                },
                _f),
            _e),
    }, _b)));
});
var FilterDialogContainer = styled('div')({
    height: '100%',
    display: 'grid',
    gridTemplateRows: '70px 1fr 83px',
});
var getStaticFilters = function () {
    return ({
        RetailPrice: [
            { name: '0to25', displayName: '$0 - $25', enable: false },
            { name: '25to50', displayName: '$25 - $50', enable: false },
            { name: '50to100', displayName: '$50 - $100', enable: false },
            { name: 'over100', displayName: 'Over $100', enable: false },
        ],
        CampaignTypes: [
            {
                name: 'purchaseRewardCampaign',
                displayName: 'Purchase rewards',
                enable: false,
            },
            {
                name: 'affiliateLinkCampaign',
                displayName: 'Affiliate rewards',
                enable: false,
            },
        ],
    });
};
var getDynamicFilters = function (facetsResult) {
    var res = {};
    var categoryFacets = _get(facetsResult, ['facets', 'categoryId'], []);
    var subCategoryFacets = _get(facetsResult, ['facets', 'subCategoryId'], []);
    var retailerFacets = _get(facetsResult, ['facets', 'retailerId'], []);
    var brandFacets = _get(facetsResult, ['facets', 'brandId'], []);
    if (!_isEmpty(categoryFacets)) {
        res.CategoryIds = categoryFacets.map(function (category) { return ({
            name: category.categoryId,
            displayName: category.name,
            enable: false,
        }); });
    }
    if (!_isEmpty(subCategoryFacets)) {
        res.SubcategoryIds = subCategoryFacets.map(function (subCategory) { return ({
            name: subCategory.subCategoryId,
            displayName: subCategory.name,
            enable: false,
        }); });
    }
    if (!_isEmpty(retailerFacets)) {
        res.RetailerIds = retailerFacets.map(function (retailer) { return ({
            name: retailer.retailerId,
            displayName: retailer.name,
            enable: false,
        }); });
    }
    if (!_isEmpty(brandFacets)) {
        res.BrandIds = brandFacets.map(function (brand) { return ({
            name: brand.brandId,
            displayName: brand.name,
            enable: false,
        }); });
    }
    return res;
};
var convertFilterStateToSearchParams = function (filterState) {
    var searchRoute = '';
    Object.entries(filterState).forEach(function (_a) {
        var filterName = _a[0], filterValues = _a[1];
        filterValues === null || filterValues === void 0 ? void 0 : filterValues.forEach(function (option) {
            if (option.enable) {
                searchRoute += "&".concat(FilterParam[filterName], "=").concat(option.name);
            }
        });
    });
    return searchRoute;
};
var convertSearchParamToFilterState = function (searchParams, filterState) {
    var params = {};
    searchParams.forEach(function (value, key) {
        var _a;
        var decodedKey = decodeURIComponent(key);
        var decodedValue = decodeURIComponent(value);
        var filterKey = getFilterParamKeyFromValue(decodedKey);
        if (!filterKey)
            return;
        if (filterKey !== 'VersionId' && filterKey !== 'SiteId') {
            params[filterKey] = params[filterKey] || [];
            (_a = params[filterKey]) === null || _a === void 0 ? void 0 : _a.push(decodedValue);
        }
        else {
            params[filterKey] = decodedValue;
        }
    });
    var newFilterState = _cloneDeep(filterState);
    Object.entries(newFilterState).forEach(function (_a) {
        var filterName = _a[0], filterValues = _a[1];
        filterValues === null || filterValues === void 0 ? void 0 : filterValues.forEach(function (state) {
            var _a;
            if ((_a = params[filterName]) === null || _a === void 0 ? void 0 : _a.includes("".concat(state.name))) {
                state.enable = true;
            }
        });
    });
    return newFilterState;
};
var SelectOption = function (_a) {
    var _b = _a.checked, checked = _b === void 0 ? false : _b, _c = _a.displayName, displayName = _c === void 0 ? '' : _c, onChange = _a.onChange;
    return (React.createElement("div", { className: "option" },
        React.createElement(AppCheckbox, { checkboxProps: {
                checked: checked,
                sx: function (theme) { return ({
                    padding: '0px 19px 0px 0px',
                    marginLeft: '-2px',
                    '&.Mui-checked': {
                        color: theme.palette.primary.main,
                    },
                }); },
                onChange: onChange,
            }, label: "", hideLabel: true }),
        React.createElement("div", { className: "option_label" }, displayName)));
};
var FilterRow = function (_a) {
    var title = _a.title, options = _a.options, onChange = _a.onChange, props = __rest(_a, ["title", "options", "onChange"]);
    return (React.createElement("div", { className: "row" },
        React.createElement("div", { className: "row_title" }, title),
        React.createElement("div", { className: "row_options" },
            !props.hideOptions &&
                options.map(function (option) {
                    return (React.createElement(SelectOption, { onChange: function (e, checked) {
                            onChange(option.name, checked);
                        }, key: option.name, checked: option === null || option === void 0 ? void 0 : option.enable, displayName: option === null || option === void 0 ? void 0 : option.displayName }));
                }),
            props.children)));
};
var ShowMore = function (_a) {
    var onClick = _a.onClick, className = _a.className;
    return (React.createElement(Button, { onClick: onClick, className: [className, 'show_more'].filter(Boolean).join(' '), variant: "text", sx: {
            width: 'fit-content',
            fontWeight: 500,
        } }, "Show more"));
};
var FilterContent = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h;
    var searchInput = _a.searchInput, applyFilter = _a.applyFilter, setSearchInput = _a.setSearchInput, filterState = _a.filterState, toggleFilterState = _a.toggleFilterState;
    var _j = useState(SHOW_MORE_INITIAL_LIMIT), categoryIdsLimit = _j[0], setCategoryIdsLimit = _j[1];
    var _k = useState(SHOW_MORE_INITIAL_LIMIT), subcategoryIdsLimit = _k[0], setSubcategoryIdsLimit = _k[1];
    var _l = useState(SHOW_MORE_INITIAL_LIMIT), brandIdsLimit = _l[0], setBrandIdsLimit = _l[1];
    var brandIds = useMemo(function () {
        var _a;
        return (_a = filterState === null || filterState === void 0 ? void 0 : filterState.BrandIds) === null || _a === void 0 ? void 0 : _a.slice(0, brandIdsLimit);
    }, [filterState === null || filterState === void 0 ? void 0 : filterState.BrandIds, brandIdsLimit]);
    var categoryIds = useMemo(function () {
        var _a;
        return (_a = filterState === null || filterState === void 0 ? void 0 : filterState.CategoryIds) === null || _a === void 0 ? void 0 : _a.slice(0, categoryIdsLimit);
    }, [filterState === null || filterState === void 0 ? void 0 : filterState.CategoryIds, categoryIdsLimit]);
    var subcategoryIds = useMemo(function () {
        var _a;
        return (_a = filterState === null || filterState === void 0 ? void 0 : filterState.SubcategoryIds) === null || _a === void 0 ? void 0 : _a.slice(0, subcategoryIdsLimit);
    }, [filterState === null || filterState === void 0 ? void 0 : filterState.SubcategoryIds, subcategoryIdsLimit]);
    var categoryShowMore = categoryIdsLimit < ((_c = (_b = filterState === null || filterState === void 0 ? void 0 : filterState.CategoryIds) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0);
    var subCategoryShowMore = subcategoryIdsLimit < ((_e = (_d = filterState === null || filterState === void 0 ? void 0 : filterState.SubcategoryIds) === null || _d === void 0 ? void 0 : _d.length) !== null && _e !== void 0 ? _e : 0);
    var brandShowMore = brandIdsLimit < ((_g = (_f = filterState === null || filterState === void 0 ? void 0 : filterState.BrandIds) === null || _f === void 0 ? void 0 : _f.length) !== null && _g !== void 0 ? _g : 0);
    var anyRewardChecked = !!((_h = filterState === null || filterState === void 0 ? void 0 : filterState.CampaignTypes) === null || _h === void 0 ? void 0 : _h.find(function (type) { return type === null || type === void 0 ? void 0 : type.enable; }));
    return (React.createElement(FilterContentContainer, null,
        React.createElement("div", { className: "row mobile_search_bar" },
            React.createElement(TextField, { variant: "standard", placeholder: "Search products", value: searchInput, onKeyDown: function (e) {
                    if (e.key === 'Enter') {
                        applyFilter();
                    }
                }, onChange: function (event) { return setSearchInput(event.target.value); }, inputProps: { maxLength: 200 }, InputProps: {
                    disableUnderline: true,
                    startAdornment: React.createElement(SearchIcon, { color: "primary", sx: { marginRight: 1.25, fontSize: 13 } }),
                }, sx: function (theme) { return ({
                    borderRadius: 17,
                    height: 38,
                    width: '100%',
                    flex: 1,
                    backgroundColor: brandclub_colors.blueWhite,
                    '& div.MuiInput-root': {
                        padding: '0 4px 0 14px',
                        display: 'flex',
                        alignItems: 'center',
                        height: 38,
                        '& input': {
                            padding: 0,
                            fontSize: 12,
                            fontWeight: 500,
                            fontFamily: 'Poppins',
                            color: theme.palette.primary.main,
                        },
                    },
                }); } })),
        (filterState === null || filterState === void 0 ? void 0 : filterState.CampaignTypes) && (React.createElement(FilterRow, { title: "Rewards", options: filterState.CampaignTypes, onChange: function (name, enabled) { return toggleFilterState('CampaignTypes', name, enabled); }, hideOptions: !anyRewardChecked },
            React.createElement("div", { className: "option_reward ".concat(anyRewardChecked ? 'right' : '') },
                React.createElement(BrandclubFilterSwitch, { sx: { margin: '2px 0px' }, checked: anyRewardChecked, onChange: function (_, checked) { return toggleFilterState('CampaignTypes', null, checked); } }),
                React.createElement("div", { className: "toggle_text" }, "Only show products with reward offers")))),
        (filterState === null || filterState === void 0 ? void 0 : filterState.RetailPrice) && (React.createElement(FilterRow, { title: "Price", options: filterState.RetailPrice, onChange: function (name, enabled) { return toggleFilterState('RetailPrice', name, enabled); } })),
        (filterState === null || filterState === void 0 ? void 0 : filterState.RetailerIds) && (React.createElement(FilterRow, { title: "Stores", options: filterState.RetailerIds, onChange: function (name, enabled) { return toggleFilterState('RetailerIds', name, enabled); } })),
        brandIds && (React.createElement(FilterRow, { title: "Brands", options: brandIds, onChange: function (name, enabled) { return toggleFilterState('BrandIds', name, enabled); } }, brandShowMore && (React.createElement(ShowMore, { onClick: function () {
                setBrandIdsLimit(function (prevLimit) { return prevLimit + SHOW_MORE_LIMIT; });
            } })))),
        categoryIds && (React.createElement(FilterRow, { title: "Categories", options: categoryIds, onChange: function (name, enabled) { return toggleFilterState('CategoryIds', name, enabled); } }, categoryShowMore && (React.createElement(ShowMore, { onClick: function () {
                setCategoryIdsLimit(function (prevLimit) { return prevLimit + SHOW_MORE_LIMIT; });
            } })))),
        subcategoryIds && (React.createElement(FilterRow, { title: "Subcategories", options: subcategoryIds, onChange: function (name, enabled) { return toggleFilterState('SubcategoryIds', name, enabled); } }, subCategoryShowMore && (React.createElement(ShowMore, { onClick: function () {
                setSubcategoryIdsLimit(function (prevLimit) { return prevLimit + SHOW_MORE_LIMIT; });
            } }))))));
};
var FilterDialog = function (_a) {
    var onCloseSearchDropdown = _a.onCloseSearchDropdown, searchInput = _a.searchInput, setSearchInput = _a.setSearchInput, brandId = _a.brandId, navigate = _a.navigate, open = _a.open, onClose = _a.onClose, persistentQueryParams = _a.persistentQueryParams, searchParams = _a.searchParams, pageContext = _a.pageContext, axios = _a.axios, routePrefix = _a.routePrefix;
    var _b = useState({}), originFilterState = _b[0], setOriginFilterState = _b[1];
    var _c = useState({}), filterState = _c[0], setFilterState = _c[1];
    var desktopView = useMediaQuery("(min-width:".concat(TABLET_SCREEN_SIZE, "px)"));
    useEffect(function () {
        var generateCurrentFilters = function () { return __awaiter(void 0, void 0, void 0, function () {
            var searchRequestBody, facetsResult, originFilterState, newFilterState;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        searchRequestBody = searchParamsToSearchFilters(searchParams, pageContext, brandId);
                        return [4 /*yield*/, searchProductsRest(axios, searchRequestBody, { start: 0, size: 0 }, {
                                computeFacets: true,
                                facetFieldNames: ['categoryId', 'retailerId', 'subCategoryId', 'brandId'],
                            }, undefined)];
                    case 1:
                        facetsResult = _a.sent();
                        originFilterState = __assign(__assign({}, getStaticFilters()), getDynamicFilters(facetsResult));
                        newFilterState = convertSearchParamToFilterState(searchParams, originFilterState);
                        setOriginFilterState(originFilterState);
                        setFilterState(newFilterState);
                        return [2 /*return*/];
                }
            });
        }); };
        generateCurrentFilters();
    }, [searchParams, brandId]);
    var toggleFilterState = function (filterName, filterValue, enabled) {
        var _a;
        var filterStateClone = _cloneDeep(filterState);
        (_a = filterStateClone[filterName]) === null || _a === void 0 ? void 0 : _a.forEach(function (option) {
            if (filterValue === null || option.name === filterValue) {
                option.enable = enabled;
            }
        });
        setFilterState(filterStateClone);
    };
    var applyFilter = function () {
        var searchUrl = routePrefix + "/search?";
        var searchParams = convertFilterStateToSearchParams(filterState);
        if (searchInput) {
            var encodedSearchInput = encodeURIComponent(searchInput.trim());
            searchUrl += "".concat(FilterParam.TitleInclude, "=").concat(encodedSearchInput);
        }
        searchUrl += searchParams;
        if (persistentQueryParams) {
            searchUrl += "&".concat(persistentQueryParams);
        }
        onCloseSearchDropdown === null || onCloseSearchDropdown === void 0 ? void 0 : onCloseSearchDropdown();
        navigate(searchUrl);
        setFilterState({});
        onClose();
    };
    return (React.createElement(Dialog, { fullScreen: !desktopView, TransitionComponent: desktopView ? undefined : Transition, onClose: onClose, PaperProps: {
            style: {
                height: desktopView ? 800 : '100%',
                maxWidth: 'unset',
                boxShadow: 'rgba(149, 157, 165, 0.2) 0px 8px 24px',
            },
        }, BackdropProps: {
            sx: {
                backgroundColor: brandclub_colors.darkBlue3,
                transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
            },
        }, style: { zIndex: 1500 }, open: open },
        React.createElement(FilterDialogContainer, null,
            React.createElement(FilterHeader, null,
                React.createElement("div", { className: "left" },
                    React.createElement(CloseRoundedIcon, { color: "primary", onClick: onClose, sx: { cursor: 'pointer' } })),
                React.createElement("div", { className: "center" }, "Filter"),
                React.createElement("div", { className: "right", role: "button", style: { cursor: 'pointer' }, onClick: function () {
                        setFilterState(originFilterState);
                        setSearchInput('');
                    } }, "Clear")),
            React.createElement(FilterContent, { searchInput: searchInput, setSearchInput: setSearchInput, applyFilter: applyFilter, filterState: filterState, toggleFilterState: toggleFilterState }),
            React.createElement(FilterFooter, null,
                React.createElement("button", { className: "apply_button", onClick: applyFilter }, "Apply")))));
};

export { FilterDialog };
//# sourceMappingURL=FilterDialog.js.map
